module.exports = __webpack_public_path__ + "static/img/greentousu.1f06e9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xinyuan/greentousu.png
// module id = YH4C
// module chunks = 0